import { billingSummarySetupWidgetDataSelector } from "./billingSummarySetupWidgetDataSelector";
import { RootState } from "../../../../../store";

export const billingSummarySetupWidgetNoMonthlyAverageSelector = (
  state: RootState,
) => {
  return !billingSummarySetupWidgetDataSelector(state)
    ?.average_monthly_cost_details?.average_monthly_cost;
};
